import type { FlowItemContent, FlowModuleType } from "@care-by-ella/contracts";

// Shared title extractor for a flow step's localized content, used by both the
// patient timeline and the flow builder so the same step never shows two
// different titles. Returns "" when no surface carries a title — callers add
// their own fallback (e.g. a module-type label or "(utan titel)").
export function flowContentTitle(
  content: FlowItemContent,
  moduleType?: FlowModuleType,
): string {
  // A chat_message carries no card title — identify it by its message body and
  // ignore any dormant home/push/email copy left on the item from a prior type.
  if (moduleType === "chat_message") return content.chatMessage?.body.sv ?? "";
  return (
    content.home?.title.sv ||
    content.push?.title.sv ||
    content.email?.subject.sv ||
    ""
  );
}
